export function isHeaderEnabled(window: Window) {
  const appRoot = window.document.querySelector('app-root');
  if (appRoot === null) {
    return false;
  }
  const withHeader = appRoot.getAttribute('with-header')
  return withHeader === 'true';
}
